module.exports = __webpack_public_path__ + "static/img/4197_phase_function_Paper_PointsHejduk_Prediction.be6fb14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4197_phase_function_Paper_PointsHejduk_Prediction.png
// module id = +CGO
// module chunks = 0